<ba-studisu-ergebnisliste
  [searchResult]="searchResult"
  [facettenWerte]="facettenWerte"
></ba-studisu-ergebnisliste>
